/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentRef,
    Inject,
    Input,
    OnDestroy,
    Type,
    ViewChild
} from '@angular/core';
import { DialogRef } from './dialog.ref';
import { Subject } from 'rxjs';
import { InsertionDirective } from './insertion.directive';
import { THEME_TOKEN, Theme } from '../types/theme.types';
import { componentStylesByTheme } from '../utils/theme.utils';
import { dialogStylesSAG, dialogStylesSHS } from './dialog.styles';

@Component({
    selector: 'sag-ui-dialog',
    template: `<div
        class="flex fixed top-0 left-0 bottom-0 right-0 z-[200] items-center justify-center bg-[rgba(0,0,0,0.3)] backdrop-blur-sm"
        (click)="!mouseDownInside && handleOverlayClick(); mouseDownInside = false"
    >
        <div
            [class]="dialogClasses"
            (mousedown)="$event.stopPropagation(); mouseDownInside = true"
            (mouseup)="$event.stopPropagation(); mouseDownInside = false"
            (click)="mouseDownInside = true"
            [ngStyle]="getDialogStyle"
        >
            <sag-ui-focus-trap>
                <ng-template sag-ui-dialog-insertion> </ng-template>
            </sag-ui-focus-trap>
        </div>
    </div>`
})
export class DialogComponent implements AfterViewInit, OnDestroy {
    @ViewChild(InsertionDirective) insertionPoint!: InsertionDirective;
    @Input() width = 'auto';
    @Input() height = 'auto';
    @Input() backgroundColor = '';

    private readonly _onClose = new Subject<any>();
    protected mouseDownInside = false;

    public componentRef!: ComponentRef<any>;
    public childComponentType!: Type<any>;
    public onClose = this._onClose.asObservable();

    constructor(
        @Inject(THEME_TOKEN) private readonly theme: Theme,
        private cd: ChangeDetectorRef,
        private dialogRef: DialogRef<any>
    ) {}

    ngAfterViewInit() {
        this.loadChildComponent(this.childComponentType);
        this.cd.detectChanges();
    }

    protected handleOverlayClick() {
        this.dialogRef.close();
    }

    protected get getDialogStyle() {
        return {
            width: this.width,
            height: this.height,
            backgroundColor: this.backgroundColor
        };
    }

    protected get dialogClasses() {
        const inputStyles = componentStylesByTheme(this.theme, dialogStylesSAG, dialogStylesSHS);

        return inputStyles();
    }

    private loadChildComponent(componentType: Type<any>) {
        const viewContainerRef = this.insertionPoint.viewContainerRef;
        viewContainerRef.clear();

        this.componentRef = viewContainerRef.createComponent(componentType);
    }

    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    public close() {
        this._onClose.next({});
    }
}
